export default "Highlight which input pixels contribute to one output pixel. Draw the connection: each output pixel is the average of its 3x3 neighborhood.\n"